/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, period: NonNullable<unknown> }} Progress_Report_Distribution_MetaInputs */

const en_us2_progress_report_distribution_meta = /** @type {(inputs: Progress_Report_Distribution_MetaInputs) => LocalizedString} */ (i) => {
	if (i?.period === "week" && (i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`Against the previous week with training`);
	if (i?.period === "week") return /** @type {LocalizedString} */ (`Against the average of the ${i?.count} previous weeks with training`);
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`Against the previous month with training`);
	return /** @type {LocalizedString} */ (`Against the average of the ${i?.count} previous months with training`)
	
};

const pt_br2_progress_report_distribution_meta = /** @type {(inputs: Progress_Report_Distribution_MetaInputs) => LocalizedString} */ (i) => {
	if (i?.period === "week" && (i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`Contra a semana anterior com treino`);
	if (i?.period === "week") return /** @type {LocalizedString} */ (`Contra a média das ${i?.count} semanas anteriores com treino`);
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`Contra o mês anterior com treino`);
	return /** @type {LocalizedString} */ (`Contra a média dos ${i?.count} meses anteriores com treino`)
	
};

const es_419_progress_report_distribution_meta = /** @type {(inputs: Progress_Report_Distribution_MetaInputs) => LocalizedString} */ (i) => {
	if (i?.period === "week" && (i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`Frente a la semana anterior con entrenamiento`);
	if (i?.period === "week") return /** @type {LocalizedString} */ (`Frente al promedio de las ${i?.count} semanas anteriores con entrenamiento`);
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`Frente al mes anterior con entrenamiento`);
	return /** @type {LocalizedString} */ (`Frente al promedio de los ${i?.count} meses anteriores con entrenamiento`)
	
};

const pt_pt2_progress_report_distribution_meta = /** @type {(inputs: Progress_Report_Distribution_MetaInputs) => LocalizedString} */ (i) => {
	if (i?.period === "week" && (i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`Face à semana anterior com treino`);
	if (i?.period === "week") return /** @type {LocalizedString} */ (`Face à média das ${i?.count} semanas anteriores com treino`);
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`Face ao mês anterior com treino`);
	return /** @type {LocalizedString} */ (`Face à média dos ${i?.count} meses anteriores com treino`)
	
};

const fr_fr2_progress_report_distribution_meta = /** @type {(inputs: Progress_Report_Distribution_MetaInputs) => LocalizedString} */ (i) => {
	if (i?.period === "week" && (i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`Par rapport à la semaine d'entraînement précédente`);
	if (i?.period === "week") return /** @type {LocalizedString} */ (`Par rapport à la moyenne des ${i?.count} semaines d'entraînement précédentes`);
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`Par rapport au mois d'entraînement précédent`);
	return /** @type {LocalizedString} */ (`Par rapport à la moyenne des ${i?.count} mois d'entraînement précédents`)
	
};

const de_de2_progress_report_distribution_meta = /** @type {(inputs: Progress_Report_Distribution_MetaInputs) => LocalizedString} */ (i) => {
	if (i?.period === "week" && (i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`Im Vergleich zur letzten Woche mit Training`);
	if (i?.period === "week") return /** @type {LocalizedString} */ (`Im Vergleich zum Schnitt der ${i?.count} letzten Wochen mit Training`);
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`Im Vergleich zum letzten Monat mit Training`);
	return /** @type {LocalizedString} */ (`Im Vergleich zum Schnitt der ${i?.count} letzten Monate mit Training`)
	
};

const it_it2_progress_report_distribution_meta = /** @type {(inputs: Progress_Report_Distribution_MetaInputs) => LocalizedString} */ (i) => {
	if (i?.period === "week" && (i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`Rispetto alla settimana precedente con allenamenti`);
	if (i?.period === "week") return /** @type {LocalizedString} */ (`Rispetto alla media delle ${i?.count} settimane precedenti con allenamenti`);
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`Rispetto al mese precedente con allenamenti`);
	return /** @type {LocalizedString} */ (`Rispetto alla media dei ${i?.count} mesi precedenti con allenamenti`)
	
};

/**
* | period | count | output |
* | --- | --- | --- |
* | "week" | "1" | "Against the previous week with training" |
* | "week" | * | "Against the average of the {count} previous weeks with training" |
* | * | "1" | "Against the previous month with training" |
* | * | * | "Against the average of the {count} previous months with training" |
*
* @param {Progress_Report_Distribution_MetaInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_report_distribution_meta = /** @type {((inputs: Progress_Report_Distribution_MetaInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Report_Distribution_MetaInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_report_distribution_meta(inputs)
	if (locale === "es-419") return es_419_progress_report_distribution_meta(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_report_distribution_meta(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_report_distribution_meta(inputs)
	if (locale === "de-DE") return de_de2_progress_report_distribution_meta(inputs)
	if (locale === "it-IT") return it_it2_progress_report_distribution_meta(inputs)
	return en_us2_progress_report_distribution_meta(inputs)
});
export { progress_report_distribution_meta as "progress-report.distribution_meta" }